import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const statusColorMap = {
  OPEN: 'statuses.open',
  APPROVED: 'statuses.approved',
  CANCELLED: 'statuses.cancelled',
  COMPLETED: 'statuses.completed',
  INPROGRESS: 'statuses.inProgress',
  PENDING_APPROVAL: 'statuses.pendingApproval',
  CLOSED: 'statuses.closed',
  NONE: 'statuses.none',
  COMPLETE: 'statuses.completed',
  FAIL: 'statuses.failed',
  PREAUTH: 'statuses.preauth',
  DISPUTED: 'statuses.disputed',
  REFUNDED: 'statuses.refunded',
  NOTSTARTED: 'statuses.notStarted',
  STARTED: 'statuses.started',
  PREAUTHREFUNDED: 'statuses.preauthRefunded',
};

const Status = ({ status }) => {
  return (
    <Box
      component="span"
      sx={{
        color: statusColorMap[status],
        display: 'inline-flex',
        alignItems: 'center',
      }}
    >
      {status === 'COMPLETED' ? (
        <CheckIcon sx={{ fontSize: '13px', mr: '10px' }} />
      ) : (
        <FiberManualRecordIcon sx={{ fontSize: '10px', mr: '5px' }} />
      )}
    </Box>
  );
};

Status.propTypes = {
  status: PropTypes.oneOf([
    'OPEN',
    'APPROVED',
    'CANCELLED',
    'COMPLETED',
    'INPROGRESS',
    'PENDING_APPROVAL',
    'CLOSED',
    'NONE',
    'FAIL',
    'PREAUTH',
    'DISPUTED',
    'COMPLETE',
    'REFUNDED',
    'PREAUTHREFUNDED',
    'NOTSTARTED',
    'STARTED',
  ]).isRequired,
};

export default Status;
